import { j as l } from "./jsx-runtime-e6RZPHeG.js";
import { memo as s } from "react";
const i = ({
  title: e,
  titleId: o,
  ...c
}) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...c,
    children: [
      e ? /* @__PURE__ */ l.jsx("title", { id: o, children: e }) : null,
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M682.477 552.397H364.781c-23.552 0-42.667-19.115-42.667-42.667s19.115-42.667 42.667-42.667h317.696c23.552 0 42.667 19.115 42.667 42.667s-19.115 42.667-42.667 42.667m-57.43 149.333H422.231c-23.573 0-42.667-19.093-42.667-42.667 0-23.552 19.093-42.667 42.667-42.667h202.816c23.552 0 42.667 19.115 42.667 42.667 0 23.573-19.115 42.667-42.667 42.667m-203.349-384h202.795c23.595 0 42.667 19.115 42.667 42.667s-19.072 42.667-42.667 42.667H421.698c-23.573 0-42.667-19.115-42.667-42.667s19.093-42.667 42.667-42.667m63.424-187.84c-178.795 17.515-323.477 162.048-341.269 340.8-6.037 60.587 2.155 118.613 21.568 171.2a21.378 21.378 0 0 1 .085 14.528c-31.019 86.421-48.107 134.144-57.557 160.469-5.376 14.955 6.891 30.272 22.656 28.395l169.301-20.053c4.928-.597 9.835.64 13.973 3.371 69.376 45.739 154.475 69.547 245.525 61.227 180.075-16.448 326.379-161.515 344.064-341.461 23.68-241.152-177.216-442.091-418.347-418.475z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), n = s(i);
export {
  n as default
};
